const initBlogImageLoading = () => {
  const imageWraps = document.querySelectorAll('.article-img-loading');

  imageWraps.forEach((wrap) => {
    const img = wrap.querySelector('img');

    if (!img) return;

    const closeLoading = () => {
      wrap.classList.add('is-loaded');
    };

    const imageSrc = img.getAttribute('src');
 
    if (!imageSrc || imageSrc.trim() === '') {
      wrap.classList.add('is-empty', 'is-loaded');
      return;
    }

    // Handle cached images that have already finished loading.
    if (img.complete && img.naturalWidth > 0) {
      closeLoading();
    } else {
      img.addEventListener('load', closeLoading, { once: true });
      img.addEventListener('error', closeLoading, { once: true });
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogImageLoading);
} else {
  initBlogImageLoading();
}
